import React, { useEffect } from 'react'
import OpeningHours from '../../../../MySections/TimeSections/OpeningHours';


const TabOpeningHours = (props) => {

    let Rest = props.Rest;
    useEffect(() => {
    }, [])

    return (
        <>
            <div className={"col-md-12 mb-2 tblHours fullRow"}>
                <OpeningHours theHours={Rest.OpeningHours} SetTheHours={(hoursBk) => props.updateRest({ ...props.Rest, OpeningHours: hoursBk })} />
            </div>
        </>

    );
}

export default TabOpeningHours;